import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { cookieConsent } from './lib/cookieConsent'

// Re-apply stored analytics consent before first render so gtag's
// wait_for_update window catches the update (Consent Mode v2).
cookieConsent.applyStoredConsent();

const root = createRoot(document.getElementById("root")!);
root.render(<App />);

// Dispatch render event for prerender plugin
// This signals that the app has finished rendering
setTimeout(() => {
  document.dispatchEvent(new Event('render-event'));
}, 100);
